(function () {
  "use strict";

  const SCROLL_THRESHOLD = 100;

  let scriptsLoaded = false;

  function loadDeferredScript(scriptData) {
    const script = document.createElement("script");

    Object.keys(scriptData.attributes).forEach((attr) => {
      script.setAttribute(attr, scriptData.attributes[attr]);
    });

    if (scriptData.src) {
      script.src = scriptData.src;
    }

    script.async = true;

    document.body.appendChild(script);
  }

  function loadAllDeferredScripts() {
    if (scriptsLoaded) return;
    scriptsLoaded = true;

    if (window.__deferredScripts && window.__deferredScripts.length > 0) {
      window.__deferredScripts.forEach(loadDeferredScript);
    }
  }

  function onScroll() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      loadAllDeferredScripts();
      window.removeEventListener("scroll", onScroll);
    }
  }

  function setupTriggers() {
    window.addEventListener("scroll", onScroll, { passive: true });

    const interactionEvents = ["click", "touchstart", "keydown"];
    const onInteraction = () => {
      loadAllDeferredScripts();
      window.removeEventListener("scroll", onScroll);
      interactionEvents.forEach((event) => {
        document.removeEventListener(event, onInteraction);
      });
    };

    interactionEvents.forEach((event) => {
      document.addEventListener(event, onInteraction, {
        passive: true,
        once: true,
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupTriggers);
  } else {
    setupTriggers();
  }

  window.loadDeferredScripts = loadAllDeferredScripts;
})();
